// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PayorSharedGlobalIdModel {
    static getAttributeTypeMap() {
        return PayorSharedGlobalIdModel.attributeTypeMap;
    }
}
PayorSharedGlobalIdModel.discriminator = undefined;
PayorSharedGlobalIdModel.additionalProperties = false;
PayorSharedGlobalIdModel.attributeTypeMap = [
    {
        "name": "id",
        "baseName": "id",
        "type": "number"
    },
    {
        "name": "globalIdTypeCode",
        "baseName": "globalIdTypeCode",
        "type": "string"
    },
    {
        "name": "globalId",
        "baseName": "globalId",
        "type": "string"
    },
];
//# sourceMappingURL=payorSharedGlobalIdModel.js.map